import utils from 'utils';

import {Tabs, Tab} from '@mui/material';
import {useContext, useState, useEffect} from 'react';

import {ProductSearch} from '@components/export';
import appContext from '@/appContext';

export const CatalogMenu = (props: {
    options: {name: string, label: string}[],
    initPurpose: string,
}) => {
    const {filters, updateFilters, setMachine} = useContext(appContext).productsContext;

    const [currentTab, setCurrentTab] = useState<number | false>(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const handle = {
        clickCategory(id: string) {
            const index = props.options.findIndex((option) => option.name === id);

            updateFilters({
                offset: 0,
                attributes: filters.attributes.filter((filter) => filter.name === 'common'),
                // machineType: data.links[index].name,
                purpose: index === currentTab ? '' : props.options[index].name,
            });

            setMachine({
                brand: '',
                model: '',
                purpose: '',
            });
        },
        syncPurposeToTab() {
            const index = props.options.findIndex((option) => option.name === filters.purpose);

            setCurrentTab(index < 0 ? false : index);
        },
    };

    useEffect(() => {
        if (props.options[0].name && !isLoaded) {
            if (props.initPurpose) {
                handle.clickCategory(props.initPurpose);
            }

            setIsLoaded(true);
        }
    }, [props.options]);

    useEffect(() => {
        handle.syncPurposeToTab();
    }, [filters.purpose]);

    return <div className={cmpClass}>
        <div className={classMap.container}>
            <div className={classMap.list}>
                <Tabs
                    value={currentTab}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {
                        props.options.map((link, index: number) => {
                            return <Tab
                                label={link.label}
                                id={link.name}
                                key={link.name}
                                onClick={(e) => handle.clickCategory((e.target as HTMLElement).id)}
                                className={classMap.item + (
                                    props.options[index].name ? ' ' + classMap.itemActive : ''
                                )}
                            />;
                        })
                    }
                </Tabs>
            </div>
            <ProductSearch />
        </div>
    </div>;
};

const cmpClass = 'catalog-menu';
const classMap = utils.generateClassMap(cmpClass, {
    container: 'container container',
    list: 'list',
    item: 'item',
    itemActive: 'item--active',
    inputSearch: 'link',
    iconSearch: 'icon iconfa-search',
});
